import { useState, useEffect } from 'react';

import { useAuth, User } from 'oidc-react';

import { clusterApi } from '../api/clusterApi';
import { ClusterStatus } from '../types/cluster';

let cache: ClusterStatus[];

export default function useClusters(refresh = true) {
  const [clusters, setData] = useState<ClusterStatus[]>(cache || []);
  const [loading, setLoading] = useState(!cache?.length);
  const [error, setError] = useState(null as any);
  const auth = useAuth();
  const api = clusterApi(auth.userData as User);
  // const [api, setApi] = useState(clusterApi(auth.userData as User));

  // useEffect(() => {
  //   setApi(clusterApi(auth.userData as User));
  // }, [auth?.userData?.access_token, auth.userData, auth?.userData?.expired]);

  useEffect(() => {
    const loadClusters = async () => {
      try {
        // Only try to load if we have a valid user
        if (auth?.userData?.access_token) {
          const c = await api.listClusters();
          cache = c;
          setData(c || []);
          setError(null);
        }
      } catch (e: any) {
        console.error('Error loading cluster data: ', e);
        // Don't overwrite data with empty array if we have existing data
        if (!cache?.length) {
          setData([]);
        }
        
        // Set error but don't throw - let the app continue working with existing data
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    // Initial load
    loadClusters();
    
    // Set up interval for refreshing data
    if (refresh) {
      const t = setInterval(loadClusters, 10_000);
      return () => {
        clearInterval(t);
      };
    }
  }, [auth?.userData?.access_token, refresh]);

  return {
    loading,
    error,
    clusters,
    createCluster: api.createCluster,
    deleteCluster: api.deleteCluster,
    refreshCluster: api.refreshCluster,
    checkExists: api.checkExists,
    listDNS: api.listDNS,
  };
}
